import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectAuthUser } from '../../redux/auth/auth.selectors';
import { signOut } from '../../redux/auth/auth.actions';

import './OnboardingUserMenu.scss';

export const OnboardingUserMenu = () => {
    const dispatch = useDispatch();
    const currentUser = useSelector(selectAuthUser);

    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    // Close on outside-click / Escape, only while the menu is open.
    useEffect(() => {
        if (!open) return undefined;

        const handlePointerDown = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [open]);

    if (!currentUser) return null;

    const handleLogout = () => {
        setOpen(false);
        // Fire-and-forget: the auth reducer clears currentUser; App.js then
        // redirects to /login. Mirrors the Invitation page.
        dispatch(signOut());
    };

    return (
        <div className="wo-user-wrap" ref={rootRef}>
            <div className={`wo-user ${open ? 'open' : ''}`} onClick={() => setOpen((v) => !v)}>
                <div>Logged in as </div>
                <div className="wo-user-email">{currentUser.email}</div>
            </div>

            {open && (
                <div className="wo-user-menu">
                    <button className="wo-user-menu-item" onClick={handleLogout}>Log out</button>
                </div>
            )}
        </div>
    );
};

export default OnboardingUserMenu;
